import React, { useId, useRef, useState } from 'react';
import { CreateFormCancelButton, CreateFormDialog, CreateFormSubmitButton } from './CreateFormDialog';

/** Mount when entering edit mode: cancelled drafts never replace the saved record. */
export default function EditFormDialog({
  open,
  title,
  icon,
  initialValue,
  onSave,
  onClose,
  saveLabel = 'Salva',
  children,
  className,
  formClassName,
  comments,
}) {
  const formId = useId();
  const [value, setValue] = useState(() => ({ ...initialValue }));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const pending = useRef(false);
  const onFieldChange = (field, next) => setValue((previous) => ({ ...previous, [field]: next }));

  async function submit(event) {
    event.preventDefault();
    if (pending.current || !onSave) return;
    pending.current = true;
    setSaving(true);
    setError('');
    try {
      const result = await onSave(value);
      if (result?.ok === false) {
        setError(result.message || 'Salvataggio non riuscito. Riprova.');
      } else {
        onClose();
      }
    } catch (cause) {
      setError(cause.message || 'Salvataggio non riuscito. Riprova.');
    } finally {
      pending.current = false;
      setSaving(false);
    }
  }

  return (
    <CreateFormDialog
      open={open}
      className={className}
      title={title}
      icon={icon}
      busy={saving}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
      footer={
        <>
          <CreateFormCancelButton disabled={saving} onClick={onClose} />
          <CreateFormSubmitButton form={formId} saving={saving} disabled={!onSave}>
            {saveLabel}
          </CreateFormSubmitButton>
        </>
      }
    >
      {error ? (
        <p role="alert" className="custom-fields-section__error wt-inline-error">
          {error}
        </p>
      ) : null}
      <form id={formId} className={formClassName} onSubmit={submit}>
        {children({ value, onFieldChange, saving })}
      </form>
      {comments}
    </CreateFormDialog>
  );
}
